(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('historicoAplicacoes', HistoricoAplicacoes);

  function HistoricoAplicacoes() {
    return {
      restrict: 'E',
      controller: 'HistoricoAplicacoesWrapperCtrl',
      controllerAs: 'appWrap',
      templateUrl: 'views/painel_propriedade/_historico_aplicacoes.html'
    };
  }
}());
